// components/SnackBar.jsx
import Success from "../../assets/icons/ic_success.svg";
import Error from "../../assets/icons/ic_error.svg";
import Info from "../../assets/icons/ic_infoImg.svg";
import Warning from "../../assets/icons/ic_warning.svg";

const SnackBar = ({ type = "", message = "" }) => {
  const iconMap = {
    success: <img src={Success} alt="Success" className="" />,
    error: <img src={Error} alt="Error" className="" />,
    info: <img src={Info} alt="Info" className="" />,
    warning: <img src={Warning} alt="Warning" className="" />,
  };

  const getBgClass = () => {
    switch (type) {
      case "success":
        return "bg-snackSuccessBg border-snackSuccessBorder";
      case "error":
        return "bg-snackErrorBg border-snackErrorBorder";
      case "warning":
        return "bg-orange-100 border-snackWarningBorder";
      case "info":
      default:
        return "bg-snackInfoBg border-snackInfoBorder";
    }
  };

  return (
    <div
      className={`flex items-center gap-2 shadow-lg px-4 py-2 rounded-[14px] border border-gray-200 text-sm min-w-[280px] max-w-fit ${getBgClass()}`}
    >
      {iconMap[type]}
      <p
        className={`${
          type === "success"
            ? "text-snackSuccessBorder"
            : type === "error"
            ? "text-snackErrorBorder"
            : type === "info"
            ? "text-blue-600"
            : type === "warning"
            ? "text-yellow-600"
            : "text-snackText"
        } text-xs font-medium capitalize`}
      >
        {type}!
      </p>

      <span className="text-snackText text-xs font-normal">{message}</span>
    </div>
  );
};

export default SnackBar;
